"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import type { CicStatement } from "@/entities/IProfile";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { TOOLTIP_STYLES } from "@/helpers/tooltip.helpers";
import { STATEMENT_GROUP } from "@/helpers/Types";
import { commonApiFetch } from "@/services/api/common-api";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "next/navigation";
import { useEffect, useState } from "react";
import { Tooltip } from "react-tooltip";
import UserPageIdentityStatementsConsolidatedAddresses from "./consolidated-addresses/UserPageIdentityStatementsConsolidatedAddresses";
import UserPageIdentityStatementsContacts from "./contacts/UserPageIdentityStatementsContacts";
import UserPageIdentityAddStatementsHeader from "./header/UserPageIdentityAddStatementsHeader";
import UserPageIdentityStatementsNFTAccounts from "./nft-accounts/UserPageIdentityStatementsNFTAccounts";
import UserPageIdentityStatementsSocialMediaAccounts from "./social-media-accounts/UserPageIdentityStatementsSocialMediaAccounts";
import UserPageIdentityStatementsSocialMediaVerificationPosts from "./social-media-verification-posts/UserPageIdentityStatementsSocialMediaVerificationPosts";
export default function UserPageIdentityStatements(t0) {
  const $ = _c(46);
  const {
    profile
  } = t0;
  const params = useParams();
  let t1;
  if ($[0] !== params?.user) {
    t1 = (params?.user as string)?.toLowerCase();
    $[0] = params?.user;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const user = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [socialMediaAccounts, setSocialMediaAccounts] = useState(t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const [contacts, setContacts] = useState(t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const [nftAccounts, setNftAccounts] = useState(t4);
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [];
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const [socialMediaVerificationPosts, setSocialMediaVerificationPosts] = useState(t5);
  let t6;
  let t7;
  if ($[6] !== user) {
    t6 = [QueryKey.PROFILE_CIC_STATEMENTS, user];
    t7 = async () => {
      if (!user) {
        throw new Error("UserPageIdentityStatements attempted to fetch without a user param");
      }
      return await commonApiFetch({
        endpoint: `profiles/${user}/cic/statements`
      });
    };
    $[6] = user;
    $[7] = t6;
    $[8] = t7;
  } else {
    t6 = $[7];
    t7 = $[8];
  }
  const t8 = !!user;
  let t9;
  if ($[9] !== t6 || $[10] !== t7 || $[11] !== t8) {
    t9 = {
      queryKey: t6,
      queryFn: t7,
      enabled: t8
    };
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const {
    isLoading,
    data: statements
  } = useQuery(t9);
  let t10;
  let t11;
  if ($[13] !== statements) {
    t10 = () => {
      if (!statements) {
        setNftAccounts([]);
        setSocialMediaAccounts([]);
        setContacts([]);
        setSocialMediaVerificationPosts([]);
        return;
      }
      const sortedStatements = [...statements].sort(_temp);
      setSocialMediaAccounts(sortedStatements.filter(_temp2));
      setContacts(sortedStatements.filter(_temp3));
      setNftAccounts(sortedStatements.filter(_temp4));
      setSocialMediaVerificationPosts(sortedStatements.filter(_temp5));
    };
    t11 = [statements];
    $[13] = statements;
    $[14] = t10;
    $[15] = t11;
  } else {
    t10 = $[14];
    t11 = $[15];
  }
  useEffect(t10, t11);
  let t12;
  if ($[16] !== profile) {
    t12 = <UserPageIdentityAddStatementsHeader profile={profile} />;
    $[16] = profile;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== profile) {
    t13 = <div><UserPageIdentityStatementsConsolidatedAddresses profile={profile} /></div>;
    $[18] = profile;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== isLoading || $[21] !== profile || $[22] !== socialMediaAccounts) {
    t14 = <div><UserPageIdentityStatementsSocialMediaAccounts statements={socialMediaAccounts} profile={profile} loading={isLoading} /></div>;
    $[20] = isLoading;
    $[21] = profile;
    $[22] = socialMediaAccounts;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== isLoading || $[25] !== nftAccounts || $[26] !== profile) {
    t15 = <div><UserPageIdentityStatementsNFTAccounts statements={nftAccounts} profile={profile} loading={isLoading} /></div>;
    $[24] = isLoading;
    $[25] = nftAccounts;
    $[26] = profile;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== contacts || $[29] !== isLoading || $[30] !== profile) {
    t16 = <div><UserPageIdentityStatementsContacts statements={contacts} profile={profile} loading={isLoading} /></div>;
    $[28] = contacts;
    $[29] = isLoading;
    $[30] = profile;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== isLoading || $[33] !== profile || $[34] !== socialMediaVerificationPosts) {
    t17 = <div><UserPageIdentityStatementsSocialMediaVerificationPosts statements={socialMediaVerificationPosts} profile={profile} loading={isLoading} /></div>;
    $[32] = isLoading;
    $[33] = profile;
    $[34] = socialMediaVerificationPosts;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t13 || $[37] !== t14 || $[38] !== t15 || $[39] !== t16 || $[40] !== t17) {
    t18 = <div className="tw-mt-2 lg:tw-mt-4 tw-scroll-py-3 tw-overflow-auto tw-scrollbar-thin tw-scrollbar-thumb-iron-700 tw-scrollbar-track-transparent desktop-hover:hover:tw-scrollbar-thumb-iron-500"><div className="tw-relative tw-pb-6 lg:tw-pb-8 tw-mx-auto tw-grid tw-grid-cols-1 xl:tw-gap-x-8 xl:tw-gap-y-2 lg:tw-mx-0 xl:tw-grid-cols-5"><div className="tw-col-span-full tw-space-y-6 md:tw-space-y-8"><div className="tw-grid tw-grid-cols-1 tw-gap-y-6">{t13}{t14}{t15}{t16}{t17}</div></div></div></div>;
    $[36] = t13;
    $[37] = t14;
    $[38] = t15;
    $[39] = t16;
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Tooltip id="statements-help" place="top" positionStrategy="fixed" offset={8} opacity={1} style={TOOLTIP_STYLES}><ul className="tw-m-0 tw-py-2 tw-pl-4 tw-list-disc tw-text-iron-300 tw-font-normal tw-space-y-1"><li>All statements are optional.</li><li>All statements are fully and permanently public.</li><li>Seize does not connect to social media accounts or verify posts.</li><li>The community will rate the accuracy of statements.</li></ul></Tooltip>;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== t12 || $[44] !== t18) {
    t20 = <div className="lg:tw-border-t lg:tw-border-x-0 lg:tw-border-b-0 lg:tw-border-solid lg:tw-border-white/10 tw-pt-6 tw-px-6"><div>{t12}{t18}{t19}</div></div>;
    $[43] = t12;
    $[44] = t18;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  return t20;
}
function _temp5(s_2) {
  return s_2.statement_group === STATEMENT_GROUP.SOCIAL_MEDIA_VERIFICATION_POST;
}
function _temp4(s_1) {
  return s_1.statement_group === STATEMENT_GROUP.NFT_ACCOUNTS;
}
function _temp3(s_0) {
  return s_0.statement_group === STATEMENT_GROUP.CONTACT;
}
function _temp2(s) {
  return s.statement_group === STATEMENT_GROUP.SOCIAL_MEDIA_ACCOUNT;
}
function _temp(a, d) {
  return new Date(d.crated_at).getTime() - new Date(a.crated_at).getTime();
}